module.exports = __webpack_public_path__ + "static/img/F1.262ff25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl/F1.png
// module id = s/S2
// module chunks = 0